export const LINE_ITEM_ROW_ID_PREFIX = "line";
export const LINE_GROUP_ROW_ID_PREFIX = "group";
export const ADDON_ROW_ID_PREFIX = "addon";
export const ADD_BUTTON_ROW_ID_PREFIX = "add";
export const SPACER_ROW_ID_PREFIX = "spacer";
export const LINE_RUNNING_COLUMN_ID_PREFIX = "line_item_running";

export const ADD_BUTTON_CELL_HEIGHT = 30;
export const ROW_CELL_HEIGHT = 30;
export const SPACER_ROW_HEIGHT = 12;

export const BID_TYPE_MAIN = "Main";
export const BID_TYPE_ALT = "Alt";
export const BID_TYPE_RD = "R&D";
export const BID_TYPE_CO = "Change Order";

export const BID_TYPES = [
    BID_TYPE_MAIN,
    BID_TYPE_ALT,
    BID_TYPE_RD,
    BID_TYPE_CO,
];

export const BID_SECTION_PRODUCTION_SERVICES = "Production Services";
export const BID_SECTION_TALENT = "Talent";
export const BID_SECTION_TRAVEL = "Travel";
export const bidSections = [
    BID_SECTION_PRODUCTION_SERVICES,
    "Pre-Production",
    "Production",
    "Post-Production",
    BID_SECTION_TALENT,
    BID_SECTION_TRAVEL,
    "Hair, Make-Up, Wardrobe",
    "Stills",
    "Locations",
    "Art",
    "Digital",
    "Events",
];

export const BID_CATEGORY_PRODUCTION_SERVICES = "Production Services";
export const bidCategories = [
    BID_CATEGORY_PRODUCTION_SERVICES,
    "Crew",
    "Gear",
    "Data Handling",
    "Talent",
    "Locations",
    "Expenses",
];

export const levelOfDetails = ["LOW", "MEDIUM", "HIGH"];
export const lineItemDetailsType = ["SHOW", "HIDE", "SHOW WITHOUT HOURS RATE"];
export const resourceTypes = ["External", "Internal"];

export const BID_STATUS_DRAFT = "Drafts";
export const BID_STATUS_PENDING_EP = "Pending EP Approval";
export const BID_STATUS_PENDING_FINANCE = "Pending Finance Approval";
export const BID_STATUS_APPROVED = "EP Approved";
export const BID_STATUS_PENDING_SIGNATURE = "Pending Signature";
export const BID_STATUS_SIGNED = "Signed by Client";
export const BID_STATUS_VERSION = "Version";
export const bidStatuses = [
    BID_STATUS_DRAFT,
    BID_STATUS_PENDING_EP,
    BID_STATUS_PENDING_FINANCE,
    BID_STATUS_APPROVED,
    BID_STATUS_PENDING_SIGNATURE,
    BID_STATUS_SIGNED,
];
export const confirmedBidStatuses = [
    BID_STATUS_APPROVED,
    BID_STATUS_PENDING_SIGNATURE,
    BID_STATUS_SIGNED,
];

export const BID_ACTIVITY_SUBMITTED_EP = "submitted for EP approval";
export const BID_ACTIVITY_SUBMITTED_FINANCE = "submitted for Finance approval";
export const BID_ACTIVITY_CANCELLED = "cancelled";
export const BID_ACTIVITY_APPROVED = "approved";
export const BID_ACTIVITY_REJECTED = "rejected";
export const BID_ACTIVITY_REQUESTED_SIGNATURE = "requested signature";
export const BID_ACTIVITY_SIGNED = "signed";
export const BID_ACTIVITY_DOWNLOADED = "downloaded for signature";

export const RATE_TYPE_PERCENTAGE = "Percentage";
export const RATE_TYPE_DAYS = "Days";
export const RATE_TYPE_HOURS = "Hours";
export const RATE_TYPE_FLAT_RATE = "Flat rate";
export const RATE_TYPE_WEEKS = "Weeks";
export const rateTypes = [
    {
        name: RATE_TYPE_DAYS,
        chipColor: "success",
    },
    {
        name: RATE_TYPE_HOURS,
        chipColor: "info",
    },
    {
        name: RATE_TYPE_WEEKS,
        chipColor: "warning",
    },
    {
        name: RATE_TYPE_FLAT_RATE,
        chipColor: "error",
    },
    {
        name: RATE_TYPE_PERCENTAGE,
        chipColor: "error",
    },
];
export const INTERNAL_MARKUP = 0;
export const HOURS_PER_DAY = 8;
export const WORK_DAYS_PER_WEEK = 5;

export const TOPSHEET_SIGNATURE_LOCATION_IDENTIFYER_STRING = "SIGNATURE";
export const TOPSHEET_NAME_LOCATION_IDENTIFYER_STRING = "________NAME________";
export const TOPSHEET_DATE_LOCATION_IDENTIFYER_STRING = "________DATE________";

export const UNIT_TYPES = ["Days", "Hours", "Weeks", "Months"];
export const RESOURCE_TYPES = ["External", "Internal"];

export const BID_SETTINGS_HEIGHT = 70;
